import { connect } from 'react-redux';
import {
  IPhraseDetailsTabTranslationNativeLangEvents,
  IPhraseDetailsTabTranslationNativeLangFields
} from '../components/types';
import { PhraseDetailsTabTranslationNativeLang } from '../components/PhraseDetailsTabTranslationNativeLang';
import { IState } from '../../../../../../store/types';
import { IPhraseDetailsTabTranslationNativeLangHOCOwnProps } from './types';
import { LangUtil } from '../../../../../../../common/utils/lang-util';
import { Wording } from '../wordings';
import { getActiveUserGroup, getUserGroupTitle } from '../../../../../../store/models/selectors';
import { PhraseDetailsTabTranslationNativeLangEvents } from './events';

const mapStateToProps = (
  dispatch: any
) => {
  return (
    state: IState,
    {langCode, color}: IPhraseDetailsTabTranslationNativeLangHOCOwnProps
  ): IPhraseDetailsTabTranslationNativeLangFields => {
    const group = getActiveUserGroup(state);
    let groupName = '';
    let helpMessage = '';
    if (group) {
      groupName = getUserGroupTitle(state, group);
      helpMessage = Wording.TRANSLATION_NATIVE_LANG_HELP.replaceAll('{groupName}', groupName);
    }
    const langName = LangUtil.getLangNameByCode(langCode);

    return {
      langName,
      color,
      helpMessage,
    }
  };
}

const mapDispatchToProps = (
  dispatch: any
): IPhraseDetailsTabTranslationNativeLangEvents => ({
    onOpenGroup: () => dispatch(PhraseDetailsTabTranslationNativeLangEvents.onOpenGroup())
  }
);

export const PhraseDetailsTabTranslationNativeLangHOC = connect(
  mapStateToProps,
  mapDispatchToProps
)(PhraseDetailsTabTranslationNativeLang);

PhraseDetailsTabTranslationNativeLangHOC.displayName = 'PhraseDetailsTabTranslationNativeLangHOC';
